import { IsNumber, IsOptional, IsString } from 'class-validator';

export class PropertyTaxesAndFeesDto {
  @IsOptional()
  @IsNumber()
  notaryFeesCents?: number;

  @IsOptional()
  @IsNumber()
  propertyTaxCents?: number; // Taxe foncière €/an

  @IsOptional()
  @IsNumber()
  housingTaxCents?: number; // Taxe d'habitation €/an

  @IsOptional()
  @IsNumber()
  wasteCollectionTaxCents?: number; // TEOM €/an
}

export class PropertyFinancialsDto {
  @IsNumber()
  sellingPriceCents!: number;

  @IsOptional()
  @IsNumber()
  chargesCents?: number; // €/mois

  @IsOptional()
  @IsNumber()
  coOwnershipChargesCents?: number; // €/mois

  @IsOptional()
  taxesAndFees?: PropertyTaxesAndFeesDto;

  @IsOptional()
  @IsString()
  precisions?: string;
}
